import request from "../utils/fetch";

//首页企业统计(设备)
export function indexlist(data) {
    return request({
      url: "/equipment/enterprise/countEquipment",
      method: "get",
      requestBody: "query",
      loading: true,
      params: data,
    });
  }


//首页企业统计(订单)
  export function indexlistMo(data) {
    return request({
      url: "/order/enterprise/statistics/get/home",
      method: "get",
      requestBody: "query",
      loading: true,
      params: data,
    });
  }


//首页本月数据走势
export function indexEc(data) {
  return request({
    url: "/order/enterprise/statistics/get/month/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 首页本周数据走势
export function indexEi(data) {
  return request({
    url: "/order/enterprise/statistics/get/seven/day/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}